export function isValidMongoId(id) {
  const objectIdRegex = /^[a-f\d]{24}$/i; // Matches 24 hexadecimal characters
  return objectIdRegex.test(id);
}
